import { Injectable } from '@angular/core';

import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class DomObjectService {
    constructor(private dataTask: DataTaskService) {}

    /**
     * @datatask 3032
     * @param params parent and child domain-object keys.
     * @returns the domain object being edited.
     */
    public async getDomObject(params: GetDomObjectParams): Promise<DomObjectGet> {
        return (await this.dataTask.Post(3032, params))[0];
    }

    /**
     * @datatask 3033
     * @returns the available domain-object types.
     */
    public listDomObjectTypes(): Promise<DomObjectTypeItem[]> {
        return this.dataTask.Post(3033, {});
    }
}

export interface GetDomObjectParams {
    domobject_keyno_parent: string | number;
    domobject_keyno_child: string | number;
}

export interface DomObjectGet {
    domobject_keyno_parent: string | number;
    domobject_name_parent: string;
    domobject_keyno_child: string | number;
    domobject_name_child: string;
    domobjecttype_keyno: string | number;
    domobjecttype_name: string;
}

export interface DomObjectTypeItem {
    domobjecttype_keyno: string | number;
    domobjecttype_name: string;
    orderby: string | number;
}
